import React, { Component } from 'react';
import { trashOutline as trash } from 'ionicons/icons';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonButton,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
  IonSegment,
  IonSegmentButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonAlert,
  IonToast,
  IonSpinner,
  IonBadge,
  withIonLifeCycle,
} from '@ionic/react';

import VaccinesService from '../services/vaccines';
import { errorMessage } from '../utils/errorMessage';
import '../theme/service.css';

class MyVaccinesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 'waitlist',
      waitlist: [],
      proposals: [],
      appointments: [],
      loading: true,
      alert: null,
      toast: null,
    };

    this.loadAll = this.loadAll.bind(this);
  }

  async ionViewWillEnter() {
    await this.loadAll();
  }

  async loadAll() {
    this.setState({ loading: true });
    try {
      const [waitlist, proposals, appointments] = await Promise.all([
        VaccinesService.myWaitlist(),
        VaccinesService.proposals(),
        VaccinesService.appointments(),
      ]);

      this.setState({
        waitlist: waitlist.data.data || [],
        proposals: proposals.data.data || [],
        appointments: appointments.data.data || [],
        loading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  }

  async removeEntry(id) {
    try {
      await VaccinesService.removeEntry(id);
      this.setState({ toast: 'Iscrizione rimossa.' });
      this.loadAll();
    } catch (error) {
      this.setState({ toast: errorMessage(error, 'Errore durante la rimozione') });
    }
  }

  async respond(proposalId, response) {
    try {
      await VaccinesService.respond(proposalId, response);
      this.setState({
        toast:
          response === 'confirmed'
            ? 'Appuntamento confermato. Ti aspettiamo in farmacia!'
            : 'Proposta rifiutata: sei stato reinserito in lista.',
      });
      this.loadAll();
    } catch (error) {
      this.setState({ toast: errorMessage(error, 'Errore durante la risposta') });
    }
  }

  async cancelAppointment(id) {
    try {
      await VaccinesService.cancelAppointment(id);
      this.setState({ toast: 'Appuntamento annullato: sei stato reinserito in lista.' });
      this.loadAll();
    } catch (error) {
      this.setState({ toast: errorMessage(error, "Errore durante l'annullamento") });
    }
  }

  canCancel(appointment) {
    if (appointment.status !== 'confirmed') return false;
    const limit = new Date(appointment.scheduled_at.replace(' ', 'T'));
    limit.setHours(limit.getHours() - (appointment.cancel_advance_hours || 24));
    return new Date() < limit;
  }

  renderWaitlist() {
    const { waitlist } = this.state;

    if (!waitlist.length) {
      return <p className="ion-padding">Non sei in nessuna lista d'attesa.</p>;
    }

    return (
      <IonList>
        {waitlist.map((entry) => (
          <IonItem key={entry.id}>
            <IonLabel>
              <h2>{entry.vaccine_name}</h2>
              {entry.codice_fiscale && (
                <p>
                  Per: {entry.fiscalcode_name ? `${entry.fiscalcode_name} (${entry.codice_fiscale})` : entry.codice_fiscale}
                </p>
              )}
              <p>Iscritto il {entry.requested_at}</p>
              {entry.status === 'waiting' ? (
                <IonBadge color="primary">In lista</IonBadge>
              ) : (
                <IonBadge color="warning">Proposta inviata</IonBadge>
              )}
            </IonLabel>
            {entry.status === 'waiting' && (
              <IonButton
                slot="end"
                fill="clear"
                color="danger"
                onClick={() =>
                  this.setState({
                    alert: {
                      header: 'Rimuovere iscrizione?',
                      message: `Vuoi uscire dalla lista d'attesa per ${entry.vaccine_name}?`,
                      action: () => this.removeEntry(entry.id),
                    },
                  })
                }
              >
                <IonIcon icon={trash} />
              </IonButton>
            )}
          </IonItem>
        ))}
      </IonList>
    );
  }

  renderProposals() {
    const { proposals } = this.state;

    if (!proposals.length) {
      return <p className="ion-padding">Nessuna proposta in attesa di risposta.</p>;
    }

    return proposals.map((group) => {
      const vaccines = (group.proposals || []).map((p) => p.vaccine_name).join(' + ');
      const firstId = (group.proposals || [])[0]?.id;

      return (
        <IonCard key={group.appointment_id}>
          <IonCardHeader>
            <IonCardTitle>{vaccines}</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <p>
              <strong>Appuntamento:</strong> {group.scheduled_at}
            </p>
            <p>
              <strong>Rispondi entro:</strong> {group.response_deadline}
            </p>
            {(group.proposals || []).some((p) => p.codice_fiscale) && (
              <p>
                <strong>Per:</strong>{' '}
                {(group.proposals || [])
                  .map((p) => (p.fiscalcode_name ? `${p.fiscalcode_name} (${p.codice_fiscale})` : p.codice_fiscale))
                  .filter(Boolean)
                  .join(', ')}
              </p>
            )}

            <IonButton
              color="success"
              onClick={() =>
                this.setState({
                  alert: {
                    header: 'Confermare?',
                    message: `Confermi l'appuntamento per ${vaccines} il ${group.scheduled_at}?`,
                    action: () => this.respond(firstId, 'confirmed'),
                  },
                })
              }
            >
              Accetta
            </IonButton>
            <IonButton
              color="danger"
              fill="outline"
              onClick={() =>
                this.setState({
                  alert: {
                    header: 'Rifiutare?',
                    message: 'Rifiutando la proposta tornerai in lista con priorità ridotta. Continuare?',
                    action: () => this.respond(firstId, 'refused'),
                  },
                })
              }
            >
              Rifiuta
            </IonButton>
          </IonCardContent>
        </IonCard>
      );
    });
  }

  renderAppointments() {
    const { appointments } = this.state;

    if (!appointments.length) {
      return <p className="ion-padding">Nessun appuntamento.</p>;
    }

    return (
      <IonList>
        {appointments.map((appointment) => (
          <IonItem key={appointment.id}>
            <IonLabel>
              <h2>{(appointment.vaccines || []).join(' + ')}</h2>
              <p>{appointment.scheduled_at}</p>
              {appointment.codice_fiscale && (
                <p>
                  Per:{' '}
                  {appointment.fiscalcode_name
                    ? `${appointment.fiscalcode_name} (${appointment.codice_fiscale})`
                    : appointment.codice_fiscale}
                </p>
              )}
              {appointment.status === 'completed' ? (
                <IonBadge color="medium">Somministrato</IonBadge>
              ) : (
                <IonBadge color="success">Confermato</IonBadge>
              )}
            </IonLabel>
            {this.canCancel(appointment) && (
              <IonButton
                slot="end"
                fill="outline"
                color="danger"
                onClick={() =>
                  this.setState({
                    alert: {
                      header: 'Annullare?',
                      message: "Annullando l'appuntamento la dose sarà riassegnata e tornerai in lista. Continuare?",
                      action: () => this.cancelAppointment(appointment.id),
                    },
                  })
                }
              >
                Annulla
              </IonButton>
            )}
          </IonItem>
        ))}
      </IonList>
    );
  }

  render() {
    const { tab, loading, alert, toast } = this.state;

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/vaccini" text="" />
            </IonButtons>
            <IonTitle>I miei vaccini</IonTitle>
          </IonToolbar>
          <IonToolbar>
            <IonSegment value={tab} onIonChange={(e) => this.setState({ tab: e.detail.value })}>
              <IonSegmentButton value="waitlist">
                <IonLabel>In lista</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="proposals">
                <IonLabel>Proposte</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="appointments">
                <IonLabel>Appuntamenti</IonLabel>
              </IonSegmentButton>
            </IonSegment>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          {loading ? (
            <div className="ion-text-center ion-padding">
              <IonSpinner />
            </div>
          ) : (
            <>
              {tab === 'waitlist' && this.renderWaitlist()}
              {tab === 'proposals' && this.renderProposals()}
              {tab === 'appointments' && this.renderAppointments()}
            </>
          )}

          <IonAlert
            isOpen={!!alert}
            header={alert?.header}
            message={alert?.message}
            buttons={[
              { text: 'Annulla', role: 'cancel' },
              { text: 'Conferma', handler: () => alert?.action && alert.action() },
            ]}
            onDidDismiss={() => this.setState({ alert: null })}
          />

          <IonToast
            isOpen={!!toast}
            message={toast || ''}
            duration={4000}
            onDidDismiss={() => this.setState({ toast: null })}
          />
        </IonContent>
      </>
    );
  }
}

export default withIonLifeCycle(MyVaccinesPage);
